import { useEffect, useState } from "react";
import axios from "axios";
import { COMPANY } from "@/lib/site";
import { Instagram, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SPANS = ["lg:col-span-3", "lg:col-span-3", "lg:col-span-3", "lg:col-span-3"];

export const InstagramFeed = () => {
  const [items, setItems] = useState([]);
  const [configured, setConfigured] = useState(false);

  useEffect(() => {
    axios.get(`${API}/instagram/feed`).then(({ data }) => {
      setConfigured(!!data?.configured);
      setItems(Array.isArray(data?.items) ? data.items.slice(0, 4) : []);
    }).catch(() => {});
  }, []);

  if (!configured || items.length === 0) return null;

  return (
    <section className="section px-6 lg:px-10 border-t border-white/10 bg-[#0B0B0D]" data-testid="instagram-feed">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-10">
        <div className="lg:col-span-7">
          <div className="eyebrow mb-4 flex items-center gap-2"><Instagram className="w-4 h-4" /> Latest From Instagram</div>
          <h2 className="font-display text-4xl md:text-6xl leading-[0.9] tracking-tighter">
            <span className="text-[#FF5722]">@aac_615</span> — fresh from the floor.
          </h2>
        </div>
        <div className="lg:col-span-5 lg:col-start-8 flex lg:justify-end">
          <a href={COMPANY.social.instagram} target="_blank" rel="noopener noreferrer" className="btn-ghost" data-testid="ig-follow">
            Follow on Instagram <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-12 gap-3">
        {items.map((it, i) => (
          <a
            key={it.id}
            href={it.permalink}
            target="_blank"
            rel="noopener noreferrer"
            className={`group relative aspect-square overflow-hidden border border-white/10 ${SPANS[i % SPANS.length]}`}
            data-testid={`ig-item-${i}`}
          >
            <img src={it.image_url} alt={it.caption?.slice(0, 60) || "Instagram post"} className="w-full h-full object-cover opacity-75 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity">
              <div className="text-white text-xs line-clamp-2">{it.caption || "View on Instagram"}</div>
            </div>
            <Instagram className="absolute top-2 right-2 w-4 h-4 text-white/60 group-hover:text-[#FF5722] transition-colors" />
          </a>
        ))}
      </div>
    </section>
  );
};
